import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { EditCommentModal } from '@src/components/EditCommentModal';
import { TrackableButton, useLocale } from 'pe-core-frontend';
import { useState } from 'react';
export const AddCommentButton = ({ commentableType, commentableId, isInternal, clientId, buttonText, onAdd, appearance, required, useMui, className, enText, tag, }) => {
    const { t } = useLocale();
    const [showModal, setShowModal] = useState(false);
    return (_jsxs(_Fragment, { children: [useMui ? (_jsx(TrackableButton, { btnType: 'mui', enText: isInternal ? 'Add Note' : enText || 'Add Comment', tag: tag, className: className, variant: 'outlined', onClick: () => setShowModal(true), children: isInternal ? t('Add Note') : buttonText || t('Add Comment') })) : (_jsx(TrackableButton, { enText: isInternal ? 'Add Note' : enText || 'Add Comment', tag: tag, className: className, buttonSize: 'small', appearance: appearance, onClick: () => setShowModal(true), children: isInternal ? t('Add Note') : buttonText || t('Add Comment') })), _jsx(EditCommentModal, { isOpen: showModal, comment: {
                    commentableId,
                    commentableType,
                    message: '',
                    isInternal,
                    id: 0,
                    clientId,
                    createdById: 0,
                    updatedById: 0,
                }, onClose: () => setShowModal(false), onSave: onAdd, required: required })] }));
};
